import { render, staticRenderFns } from "./StandardPage.vue?vue&type=template&id=5cebc7c0&"
import script from "./StandardPage.vue?vue&type=script&lang=ts&"
export * from "./StandardPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports